import { observable, makeObservable } from 'mobx';
import { NodeHistoryElement } from './NodeHistoryElement';

export class MessageNodeElement extends NodeHistoryElement {
  text: string;

  constructor() {
    super();
    this.text = ''

    makeObservable(this, {
      text: observable,
    });
  }
}
